import { render, staticRenderFns } from "./QuemDestina.vue?vue&type=template&id=2812096a&scoped=true"
import script from "./QuemDestina.vue?vue&type=script&lang=js"
export * from "./QuemDestina.vue?vue&type=script&lang=js"
import style0 from "./QuemDestina.vue?vue&type=style&index=0&id=2812096a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2812096a",
  null
  
)

export default component.exports